import { render, staticRenderFns } from "./move-table.vue?vue&type=template&id=32f21f50&scoped=true"
import script from "./move-table.vue?vue&type=script&lang=js"
export * from "./move-table.vue?vue&type=script&lang=js"
import style0 from "./move-table.vue?vue&type=style&index=0&id=32f21f50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f21f50",
  null
  
)

export default component.exports